import React from "react";
import ShortcutWidget from "./ShortcutWidget";
import MyTasksWidget from "./MyTasksWidget";
import CriticalPathWidget from "./CriticalPathWidget";
import NovedadesWidget from "./NovedadesWidget";
import RfqQuotesWidget from "./RfqQuotesWidget";

export default function WidgetRenderer({ widget, editing }) {
  if (!widget) return null;

  if (widget.type === "data") {
    switch (widget.widgetKind) {
      case "myTasks":
        return <MyTasksWidget editing={editing} />;
      case "criticalPath":
        return <CriticalPathWidget editing={editing} />;
      case "novedades":
        return <NovedadesWidget editing={editing} />;
      case "rfqQuotes":
        return <RfqQuotesWidget editing={editing} />;
      default:
        return null;
    }
  }

  return <ShortcutWidget widget={widget} editing={editing} />;
}
